const emojioneOptions = {
  styles: {
    backgroundImage: 'url(images/emojione.sprites.png)'
  }
};

export default emojioneOptions;



/** WEBPACK FOOTER **
 ** ./src/images/emojioneOptions.js
 **/